import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
import Preloader from "../Preloder/Preloader";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHandPointRight } from "@fortawesome/free-solid-svg-icons";
// import PaymentComponent from "./PaymentComponent";
import Phonepe from "./Phonepe";
// import img from '../././././../../.././backend/uploads/donateqr'
const Donate = () => {
  const [amount, setAmount] = useState("99");
  const [selectedAmount, setSelectedAmount] = useState("99");

  const handleAmountClick = (val) => {
    setAmount(val);
    setSelectedAmount(val);
  };

  const handleCustomAmount = () => {
    setSelectedAmount("custom");
    setAmount("");
  };

  const handleSubmitdonate = (e) => {
    initiatePayment(amount)
    e.preventDefault();
    // Handle the donation submission logic here
    // console.log("Submitting donation of $" + amount);
  };







  const [paymentUrl, setPaymentUrl] = useState("");
  const [merchantOrderId, setMerchantOrderId] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");

  const getAuthToken = async () => {
      try {
          const response = await axios.post(`${process.env.REACT_APP_API}/payment/get-auth-token`);
          return response.data.access_token;
      } catch (error) {
          console.error("Error fetching auth token:", error);
          return null;
      }
  };

  const generateOrderId = () => {
      const timestamp = Date.now();
      const random = Math.floor(Math.random() * 10000);
      return `ORD_${timestamp}_${random}`.slice(0, 63);
  };

  const initiatePayment = async (amount) => {
      const token = await getAuthToken();
      if (!token) return;

      const generatedOrderId = generateOrderId();
      setMerchantOrderId(generatedOrderId);

      try {
          const response = await axios.post(
            `${process.env.REACT_APP_API}/payment/initiate-payment`,
              { amount: amount, merchantOrderId: generatedOrderId, token },
              {
                  headers: {
                      Authorization: `O-Bearer ${token}`,
                      "Content-Type": "application/json",
                  },
              }
          );

          setPaymentUrl(response.data.redirectUrl);

          if (response.data.redirectUrl) {
              const tryCheckout = () => {
                  if (window.PhonePeCheckout && window.PhonePeCheckout.transact) {
                      window.PhonePeCheckout.transact({
                          tokenUrl: response.data.redirectUrl,
                          type: "IFRAME",
                          callback: function (result) {
                              // console.log("Payment Result:", result);
                              // You may call verify here if you want
                          }
                      });
                  } else {
                      window.location.href = response.data.redirectUrl;
                  }
              };

              setTimeout(tryCheckout, 500);
          }
      } catch (error) {
          console.error("Payment initiation failed:", error.response?.data || error.message);
      }
  };

  const verifyPayment = async () => {
      const token = await getAuthToken();
      if (!token || !merchantOrderId) return;

      try {
          const response = await axios.post(`${process.env.REACT_APP_API}/payment/verify-payment`, {
              merchantOrderId,
              token,
          });

          const status = response.data?.data?.state || "Unknown";
          setPaymentStatus(status);
      } catch (error) {
          console.error("Error verifying payment:", error);
          setPaymentStatus("Error fetching status");
      }
  };

  return (
    <div>
      <Preloader />
      <Header />
      <section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage:
              'url("assets/images/backgrounds/page-header-bg-1-1.jpg")',
          }}
        ></div>
        <div className="container">
          <h2 className="page-header__title">Donations</h2>
          <ul className="cleenhearts-breadcrumb list-unstyled">
            <li>
              <i className="icon-home"></i> <Link to="/">Home</Link>
            </li>
            <li>
              <span>Donations</span>
            </li>
          </ul>
        </div>
      </section>





      <div
        style={{
          width: "100%",
          height: "100px",
          backgroundColor: "#401040bd",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "10px",
        }}
      >
        <p style={{ padding: "0", margin: "0", color: "white" }}>
          click hear to donate in account{" "}
          <FontAwesomeIcon icon={faHandPointRight} />
        </p>
        <Link to='/donate_account'>
        <button
          style={{
            background:
              "linear-gradient(90deg, rgba(36,27,0,1) 0%, rgba(149,173,47,1) 12%, rgba(106,76,17,1) 35%, rgba(154,103,7,1) 51%, rgba(140,132,42,1) 69%, rgba(242,183,93,1) 100%)",
            color: "white",
          }}
        >
          Donate by account
        </button></Link>
      </div>
<div>
  
</div>



      <section className="donate-page section-space">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="donate-page__content">
             

              <form className="donate-page__form" onSubmit={handleSubmitdonate}>
                <div className="donate-page__form__amount">
                  <div className="donate-page__form__amount__box">
                    <span className="donate-page__form__amount__sign">₹</span>
                    <input
                      type="text"
                      value={amount}
                      name="donate_amount"
                      id="donate_amount"
                      placeholder="Amount"
                      className="donate-page__form__amount__input"
                      onChange={(e) => setAmount(e.target.value)}
                    />
                  </div>

                  <div className="donate-page__form__amount__buttons">
                    {["100", "500", "1000", "2000", "5000"].map((amt) => (
                      <button
                        key={amt}
                        type="button"
                        className={`donate-page__form__amount__btn donate-page__form__amount__btn--amount ${
                          selectedAmount === amt ? "active" : ""
                        }`}
                        onClick={() => handleAmountClick(amt)}
                      >
                        ₹{amt}
                      </button>
                    ))}
                    <button
                      type="button"
                      className={`donate-page__form__amount__btn ${
                        selectedAmount === "custom" ? "active" : ""
                      }`}
                      onClick={handleCustomAmount}
                    >
                      Custom amount
                    </button>
                  </div>
                </div>

             

                <div className="donate-page__form__info form-one">
                  <h3 className="donate-page__form__info__title donate-page__form__title">
                    Personal Info
                  </h3>
                  <div className="row gutter-y-30">
                    <div className="col-xl-6">
                      <div className="form-one__control">
                        <input
                          type="text"
                          name="first_name"
                          id="first_name"
                          placeholder="first name"
                          className="form-one__control__input"
                        />
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="form-one__control">
                        <input
                          type="text"
                          name="last_name"
                          id="last_name"
                          placeholder="last name"
                          className="form-one__control__input"
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-one__control">
                        <input
                          type="email"
                          name="email"
                          id="email"
                          placeholder="email address"
                          className="form-one__control__input"
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-one__control">
                        <button type="submit" className="cleenhearts-btn">
                          <span className="cleenhearts-btn__icon-box">
                            <span className="cleenhearts-btn__icon-box__inner">
                              <span className="icon-duble-arrow"></span>
                            </span>
                          </span>
                          <span className="cleenhearts-btn__text">
                            donate now
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
<Phonepe/>
      <Footer />
    </div>
  );
};

export default Donate;
